import { createContext } from 'react';

import { GtmPayload } from '@gn-audio/jss-core/common/models';

export interface ITrackingContext {
  gtmEvent: (data: GtmPayload) => void;
}

const TrackingContext = createContext<ITrackingContext>({
  gtmEvent: () => null,
});

export { TrackingContext };
